<template>
  <layout-main-inner title="场景设置">
    <div slot="action">
      <el-button
        v-if="$route.query.tagScanSceneId"
        type="primary"
        :loading="loading"
        @click="edit">更新</el-button>
      <el-button
        v-else
        type="primary"
        :loading="loading"
        @click="edit">保存</el-button>
    </div>
    <layout-card-wrap v-loading="loading">
      <div class="page-wrap">
        <div class="weapp-phone">
          <!-- app navibar -->
          <div
            class="series-item-wrap"
            :class="{ active: headers.visible }"
            @click="
              () => {
                toggle('headers');
              }
            "
          >
            <we-header-view :templateId="1" />
          </div>
          <div
            style="background-color:#000;height: 560px;overflow-y: scroll;overflow-x:hidden;"
          >
            <draggable
              v-if="seriesList.length"
              v-model="seriesList"
              :options="dragOptions"
            >
              <template v-for="(item, index) in seriesList">
                <div
                  :key="index"
                  style="cursor: grab;"
                  class="series-item-wrap"
                  :class="{ active: item.visible }"
                  @click="
                    () => {
                      toggle(undefined, index);
                    }
                  "
                >
                  <we-circular-view
                    v-if="
                      item.componentName === 'pictureadv' &&
                        item.layoutType === 0
                    "
                    :list="item.graphics"
                  />
                  <we-image-view
                    v-if="
                      item.componentName === 'pictureadv' &&
                        item.layoutType !== 0
                    "
                    :imageView="item"
                    :templateId="1"
                  />
                </div>
              </template>
            </draggable>
          </div>
          <el-button
            type="primary"
            style="margin:50px 0 10px 5px"
            @click="addSeries(2)">图片导航</el-button>
          <!-- <el-button
            type="primary"
            style="margin:50px 0 10px 5px"
            @click="addSeries(3)">轮播图</el-button> -->
        </div>
        <div class="setting-wrap">
          <we-header
            v-show="headers.visible"
            ref="header"
            v-model="headers" />
          <template v-for="(item, index) in seriesList">
            <template
              v-if="item.componentName === 'pictureadv' && item.layoutType === 0 ">
              <we-circular
                v-show="item.visible"
                :ref="'series_' + index"
                :key="index"
                v-model="seriesList[index]"
                :index="index"
                @deleteItem="deleteItem"
              />
            </template>
            <template
              v-if=" item.componentName === 'pictureadv' && item.layoutType !== 0">
              <we-image
                v-show="item.visible"
                :ref="'series_' + index"
                :key="index"
                v-model="seriesList[index]"
                :index="index"
                @deleteItem="deleteItem"
              />
            </template>
          </template>
        </div>
      </div>
    </layout-card-wrap>
  </layout-main-inner>
</template>

<script>
import './busi/index.styl'
import WeHeader from './busi/we-header.vue'
import WeHeaderView from './busi/we-header-view.vue'

import WeCircular from './busi/we-circular.vue'
import WeCircularView from './busi/we-circular-view.vue'

import WeImage from './busi/we-image.vue'
import WeImageView from './busi/we-image-view.vue'

import draggable from 'vuedraggable'
import moment from 'moment'
export default {
  name: 'WxappH5Edit',
  components: {
    WeCircularView,
    WeCircular,
    WeHeaderView,
    WeHeader,
    WeImageView,
    WeImage,
    draggable
  },
  props: {},
  data() {
    return {
      loading: false,
      dragOptions: {
        animation: 0,
        disabled: false,
        group: 'description',
        ghostClass: 'ghost'
      },
      headers: {
        visible: false,
        pageName: '',
        pageTitle: '',
        status: 1,
        sceneType: 0,
        time: null
      },
      seriesList: []
    }
  },
  mounted() {
    console.log(this.$route.query)
    this.vendorId = this.$route.query.vendorId
    if (this.$route.query.tagScanSceneId) {
      this.headers.tagScanSceneId = this.$route.query.tagScanSceneId
      this.getportalpage()
    }
    this.toggle('headers')
  },
  methods: {
    deleteItem(index) {
      this.seriesList.splice(index, 1)
    },
    toggle(ref, index) {
      if (index !== undefined) {
        this.headers.visible = false
        this.seriesList.forEach((i, idx) => {
          i.visible = idx === index
        })
      } else {
        this.headers.visible = false
        this.seriesList.forEach(i => {
          i.visible = false
        })
        this[ref].visible = true
      }
    },
    addSeries(type) {
      if (type === 3) {
        this.seriesList.push({
          componentName: 'pictureadv',
          layoutType: 0,
          graphics: [],
          visible: false
        })
      }
      if (type === 2) {
        this.seriesList.push({
          componentName: 'pictureadv',
          layoutType: 1,
          graphics: [],
          visible: false
        })
      }
    },
    edit() {
      // if (this.seriesList.length === 0) {
      //   this.$message.error('请先维护页面内容！')
      //   return
      // }
      const submitList = [this.$refs.header.submit()]
      this.seriesList.forEach((i, idx) => {
        const ref = 'series_' + idx
        console.log(ref, this.$refs[ref][0], this.$refs[ref][0].submit)
        submitList.push(this.$refs[ref][0].submit())
      })
      Promise.all(submitList)
        .then(() => {
          const list = this.seriesList.map(i => {
            if (i.componentName === 'pictureadv') {
              return {
                componentName: 'pictureadv',
                data: {
                  layoutType: i.layoutType,
                  graphics: i.graphics.map(s => {
                    return {
                      ...s,
                      image: s.image.map(img => img.url).join(',')
                    }
                  })
                }
              }
            }
            return {}
          })
          const headers = this.headers
          const time = headers.time || []
          const postData = {
            pageName: headers.pageName,
            pageTitle: headers.pageTitle,
            status: headers.status,
            sceneType: headers.sceneType,
            tagScanSceneId: headers.tagScanSceneId || null,
            wxappPageId: headers.wxappPageId || null,
            vendorId: this.vendorId,
            beginTime: time[0] ? +moment(time[0]).startOf('days') : null,
            endTime: time[1] ? +moment(time[1]).endOf('days') : null,
            vBody: [
              ...list
            ]
          }
          console.log(postData)
          this.loading = true
          const dispatch = this.headers.tagScanSceneId
            ? 'updatetagscanscene'
            : 'addtagscanscene'
          this.$store.dispatch(`gateway/${dispatch}`, {
            payload: {
              ...postData
            },
            success: () => {
              this.loading = false
              this.$router.go(-1)
            },
            fail: () => {
              this.loading = false
            }
          })
        })
        .catch(err => {
          console.log(err)
          const error = JSON.parse(err.message || '{}')

          console.dir(JSON.parse(err.message))
          if (error.pop) {
            this.toggle(error.pop)
          }
          if (Number.isInteger(error.index)) {
            this.toggle(undefined, error.index)
          }
        })
    },
    getportalpage() {
      this.loading = true
      this.$store.dispatch('gateway/gettagscanscene', {
        payload: {
          vendorId: this.vendorId,
          tagScanSceneId: this.headers.tagScanSceneId
        },
        success: res => {
          this.loading = false
          const data = res.data
          this.headers = {
            ...this.headers,
            pageName: data.pageName,
            pageTitle: data.pageTitle,
            status: data.status,
            wxappPageId: data.wxappPageId,
            sceneType: data.sceneType,
            time: data.sceneType === 1 ? [data.beginTime, data.endTime] : null
            // beginTime: data.beginTime,
            // endTime: data.endTime
          }
          const list = data.vBody.map(i => {
            if (i.componentName === 'pictureadv') {
              return {
                visible: false,
                componentName: 'pictureadv',
                layoutType: i.data.layoutType,
                graphics: i.data.graphics.map(s => {
                  return {
                    ...s,
                    image: s.image ? s.image.split(',').map(url => ({
                      url,
                      type: /(\.mp4|\.ogg|\.webm)$/g.test(url) ? 'video' : 'image' })) : []
                  }
                })
              }
            }
            return {}
          })
          this.seriesList.push(...list)
          setTimeout(() => {
            this.toggle('headers')
          }, 20)
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus">
.page-wrap {
  display: flex;
}

.setting-wrap {
  flex: 1;
  padding-left: 24px;
}

.weapp-phone {
  flex: 0 0 375px;
  width: 375px;
  border: 1px solid #f0f2f5;

  img {
    width: 100%;
    display: inline-block;
    vertical-align: top;
  }

  .active {
    position: relative;

    &::after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      top: -50%;
      right: -50%;
      bottom: -50%;
      left: -50%;
      border: 2px dashed red;
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
    }
  }

  .series-item-wrap {
    position: relative;
  }

  .series-item-wrap + .series-item-wrap {
    margin-top: 5px;
  }
}
</style>
